export const PRIVACY_TITLE = 'Política de Privacidad de Sthenus';

export const PRIVACY_LAST_UPDATED = '20 de octubre de 2026';

export const PRIVACY_COMPANY_NAME = '[NOMBRE DE LA EMPRESA]';
export const PRIVACY_ADDRESS = '[DOMICILIO]';
export const PRIVACY_EMAIL = '[EMAIL]';
export const PRIVACY_PRIVACY_EMAIL = '[EMAIL DE PRIVACIDAD]';
export const PRIVACY_URL = '[URL]';
export const PRIVACY_PORTAL_URL = process.env.REACT_APP_ADMIN_URL + '/eliminar-datos';

export const PRIVACY_HTML = `
<div class="legal-content">
  <p class="legal-text">Última actualización: ${PRIVACY_LAST_UPDATED}</p>

  <h2 class="legal-subtitle">1. Introducción</h2>
  <p>Sthenus (en adelante, "Sthenus", "nosotros" o "la Aplicación") se compromete a proteger la privacidad y los datos personales de sus usuarios.</p>
  <p>La presente Política de Privacidad describe cómo recopilamos, utilizamos, almacenamos y protegemos la información proporcionada por los usuarios al utilizar nuestros servicios.</p>
  <p>Al utilizar la Aplicación, usted acepta las prácticas descritas en esta Política.</p>

  <!--<h2 class="legal-subtitle">2. Responsable del Tratamiento de Datos</h2>
  <ul class="legal-list">
    <li class="legal-list-item">• Razón Social: ${PRIVACY_COMPANY_NAME}</li>
    <li class="legal-list-item">• Domicilio: ${PRIVACY_ADDRESS}</li>
    <li class="legal-list-item">• Correo electrónico de contacto: ${PRIVACY_EMAIL}</li>
    <li class="legal-list-item">• Sitio web: ${PRIVACY_URL}</li>
  </ul>-->

  <h2 class="legal-subtitle">3. Información que Recopilamos</h2>

  <h3 class="legal-text">Información de Registro</h3>
  <ul class="legal-list">
    <li class="legal-list-item">• Nombre</li>
    <li class="legal-list-item">• Correo electrónico</li>
    <li class="legal-list-item">• Contraseña cifrada</li>
    <li class="legal-list-item">• Fecha de registro</li>
    <li class="legal-list-item">• País o región</li>
  </ul>

  <h3 class="legal-text">Información de Perfil</h3>
  <ul class="legal-list">
    <li class="legal-list-item">• Edad</li>
    <li class="legal-list-item">• Sexo (opcional)</li>
    <li class="legal-list-item">• Peso</li>
    <li class="legal-list-item">• Estatura</li>
    <li class="legal-list-item">• Nivel de experiencia física</li>
    <li class="legal-list-item">• Objetivos de entrenamiento</li>
  </ul>

  <h3 class="legal-text">Información de Uso</h3>
  <ul class="legal-list">
    <li class="legal-list-item">• Rutinas realizadas</li>
    <li class="legal-list-item">• Historial de entrenamientos</li>
    <li class="legal-list-item">• Tiempo de actividad</li>
    <li class="legal-list-item">• Progreso registrado</li>
    <li class="legal-list-item">• Preferencias de entrenamiento</li>
  </ul>

  <h3 class="legal-text">Información Técnica</h3>
  <ul class="legal-list">
    <li class="legal-list-item">• Dirección IP</li>
    <li class="legal-list-item">• Tipo de dispositivo</li>
    <li class="legal-list-item">• Sistema operativo</li>
    <li class="legal-list-item">• Identificadores del dispositivo</li>
    <li class="legal-list-item">• Registros de errores y rendimiento</li>
  </ul>

  <h3 class="legal-text">Información de Pago</h3>
  <p>Los pagos son procesados por terceros autorizados como Apple App Store, Google Play o plataformas de pago externas.</p>
  <p>Sthenus no almacena números completos de tarjetas bancarias.</p>

  <h2 class="legal-subtitle">4. Finalidad del Tratamiento</h2>
  <p>Utilizamos la información para:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Crear y administrar cuentas.</li>
    <li class="legal-list-item">• Personalizar rutinas de entrenamiento.</li>
    <li class="legal-list-item">• Medir progreso y rendimiento.</li>
    <li class="legal-list-item">• Gestionar suscripciones y pagos.</li>
    <li class="legal-list-item">• Mejorar la experiencia de usuario.</li>
    <li class="legal-list-item">• Brindar soporte técnico.</li>
    <li class="legal-list-item">• Cumplir obligaciones legales.</li>
    <li class="legal-list-item">• Detectar actividades fraudulentas.</li>
  </ul>

  <h2 class="legal-subtitle">5. Datos Relacionados con la Salud</h2>
  <p>Algunos datos proporcionados por el usuario pueden estar relacionados con su condición física o hábitos de entrenamiento.</p>
  <p>Dicha información será utilizada exclusivamente para personalizar la experiencia dentro de la Aplicación y no será comercializada ni compartida con terceros sin autorización expresa, salvo obligación legal.</p>

  <h2 class="legal-subtitle">6. Compartición de Información</h2>
  <p>Sthenus podrá compartir información con:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Proveedores tecnológicos.</li>
    <li class="legal-list-item">• Servicios de almacenamiento en la nube.</li>
    <li class="legal-list-item">• Procesadores de pago.</li>
    <li class="legal-list-item">• Autoridades competentes cuando exista obligación legal.</li>
  </ul>
  <p>No vendemos información personal a terceros.</p>

  <h2 class="legal-subtitle">7. Conservación de Datos</h2>
  <p>Los datos serán conservados mientras:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• La cuenta permanezca activa.</li>
    <li class="legal-list-item">• Existan obligaciones legales aplicables.</li>
    <li class="legal-list-item">• Sea necesario para la prestación de los servicios.</li>
  </ul>
  <p>Posteriormente serán eliminados o anonimizados.</p>

  <h2 class="legal-subtitle">8. Derechos del Usuario</h2>
  <p>El usuario podrá solicitar:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Acceso a sus datos.</li>
    <li class="legal-list-item">• Rectificación de información incorrecta.</li>
    <li class="legal-list-item">• Eliminación de datos personales.</li>
    <li class="legal-list-item">• Limitación del tratamiento.</li>
    <li class="legal-list-item">• Revocación del consentimiento.</li>
  </ul>
  <!--<p>Las solicitudes podrán enviarse a: ${PRIVACY_PRIVACY_EMAIL}</p>-->

  <h2 class="legal-subtitle">9. Eliminación de Cuenta y Datos</h2>
  <p>El usuario podrá solicitar la eliminación de su cuenta y datos personales mediante:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Configuración de la Aplicación (si aplica).</li>
    <li class="legal-list-item">• Correo electrónico de soporte.</li>
    <li class="legal-list-item">• Portal de privacidad disponible en <a href="${PRIVACY_PORTAL_URL}" target="_blank">${PRIVACY_PORTAL_URL}</a>.</li>
  </ul>
  <p>La eliminación estará sujeta a obligaciones legales de conservación cuando correspondan.</p>

  <h2 class="legal-subtitle">10. Analítica, Diagnóstico y Tecnologías Similares</h2>
  <p>Sthenus puede utilizar cookies, SDKs y tecnologías similares para:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Analítica.</li>
    <li class="legal-list-item">• Rendimiento.</li>
    <li class="legal-list-item">• Seguridad.</li>
    <li class="legal-list-item">• Personalización.</li>
  </ul>

  <h3 class="legal-text">Google Analytics para Firebase</h3>
  <p>Sthenus utiliza Google Analytics para Firebase, un servicio de Google, para conocer cómo utilizan los usuarios la aplicación y mejorar sus funcionalidades.</p>
  <p>A través de este servicio pueden recopilarse:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Aperturas de la aplicación.</li>
    <li class="legal-list-item">• Pantallas visitadas e interacciones.</li>
    <li class="legal-list-item">• Eventos de inicio y cierre de sesión.</li>
    <li class="legal-list-item">• Identificadores técnicos del dispositivo y la instalación.</li>
    <li class="legal-list-item">• Identificador interno del usuario autenticado.</li>
    <li class="legal-list-item">• Propiedades técnicas y de perfil, como el estado de finalización del perfil.</li>
  </ul>
  <p>Esta información se utiliza para estadísticas y análisis del funcionamiento de Sthenus.</p>

  <h3 class="legal-text">Firebase Crashlytics</h3>
  <p>Sthenus utiliza Firebase Crashlytics para diagnosticar errores y mejorar la estabilidad de la aplicación.</p>
  <p>A través de este servicio puede recopilarse:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Registros de errores.</li>
    <li class="legal-list-item">• Fallas inesperadas.</li>
    <li class="legal-list-item">• Información técnica del dispositivo.</li>
    <li class="legal-list-item">• Sistema operativo.</li>
    <li class="legal-list-item">• Datos de diagnóstico.</li>
    <li class="legal-list-item">• Identificadores asociados con la instalación o cuenta.</li>
  </ul>

  <h3 class="legal-text">Tratamiento de información</h3>
  <ul class="legal-list">
    <li class="legal-list-item">• Google actúa como proveedor tecnológico de estos servicios conforme a las condiciones aplicables.</li>
    <li class="legal-list-item">• Sthenus no envía deliberadamente nombres, correos electrónicos ni tokens de autenticación como parámetros de eventos de Google Analytics.</li>
    <li class="legal-list-item">• Los datos de analítica pueden estar vinculados con el identificador interno del usuario.</li>
    <li class="legal-list-item">• La recopilación de Analytics se encuentra habilitada automáticamente en las aplicaciones nativas, sujeta a los requisitos legales aplicables.</li>
    <li class="legal-list-item">• Los usuarios pueden ejercer sus derechos de privacidad mediante los canales previstos en esta Política.</li>
  </ul>
  <p>La información sobre el tratamiento de datos por parte de Google está disponible en <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>.</p>

  <h2 class="legal-subtitle">11. Seguridad de la Información</h2>
  <p>Implementamos medidas técnicas, administrativas y organizacionales razonables para proteger la información contra:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Acceso no autorizado.</li>
    <li class="legal-list-item">• Alteración.</li>
    <li class="legal-list-item">• Pérdida.</li>
    <li class="legal-list-item">• Divulgación indebida.</li>
  </ul>
  <p>Sin embargo, ningún sistema es completamente seguro.</p>

  <h2 class="legal-subtitle">12. Menores de Edad</h2>
  <p>La Aplicación está dirigida a usuarios mayores de 13 años.</p>
  <p>Los menores deberán contar con autorización de sus padres o tutores cuando así lo exijan las leyes aplicables.</p>

  <h2 class="legal-subtitle">13. Transferencias Internacionales</h2>
  <p>Los datos podrán almacenarse o procesarse en servidores ubicados fuera del país de residencia del usuario, garantizando niveles adecuados de protección.</p>

  <h2 class="legal-subtitle">14. Modificaciones a la Política</h2>
  <p>Sthenus podrá actualizar esta Política de Privacidad en cualquier momento.</p>
  <p>Las modificaciones serán publicadas dentro de la Aplicación y entrarán en vigor desde su publicación.</p>

  <!--<h2 class="legal-subtitle">15. Contacto</h2>
  <p>Para cualquier consulta relacionada con privacidad o protección de datos:</p>
  <ul class="legal-list">
    <li class="legal-list-item">• Correo: ${PRIVACY_EMAIL}</li>
    <li class="legal-list-item">• Sitio web: ${PRIVACY_URL}</li>
  </ul>-->
</div>
`;
